import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import rootReducer from './reducers';
import redispatchMiddleware from './middlewares/redispatch-middleware';
import jsonapiMiddleware from './middlewares/jsonapi-middleware';
import issueTypesMiddleware from './middlewares/issueTypes-middleware';
import issueAttributesMiddleware from './middlewares/issueAttributes-middleware';
import issueRootCausesMiddleware from './middlewares/issueRootCauses-middleware';
import permissionsMiddleware from './middlewares/permissions-middlware';
import issueTemplatesMiddleware from './templates/issueTemplates-middleware';
import issueTemplateUsageMiddleware from './templates/issueTemplatesUsage-middleware';
import activityMiddleware from './activities/activity-middleware';
import issuesReportingMiddleware from './middlewares/issuesReporting-middleware';

const initialState = {
  issues: {
    collection: {}
  }
};

export default ({
  redispatcher,
  jsonApi,
  issuesV2Api,
  pushpinsControl,
  DevTools,
  appHistory,
  docsSDK,
  analyticsManager,
  adminApi
} = {}) => {
  // middleware executed in left-to-right order:
  const middleware = [
    thunkMiddleware.withExtraArgument({
      jsonApi,
      pushpinsControl,
      analyticsManager,
      issuesV2Api,
      redispatcher,
      docsSDK,
      appHistory,
      adminApi
    }),
    issuesReportingMiddleware(jsonApi, issuesV2Api),
    jsonapiMiddleware(jsonApi, issuesV2Api),
    issueTypesMiddleware(issuesV2Api),
    issueAttributesMiddleware(issuesV2Api),
    issueRootCausesMiddleware(issuesV2Api),
    issueTemplatesMiddleware(issuesV2Api),
    issueTemplateUsageMiddleware(issuesV2Api),
    promiseMiddleware(),
    redispatchMiddleware(redispatcher),
    permissionsMiddleware(),
    activityMiddleware(issuesV2Api)
  ];

  const enhancer = applyMiddleware(...middleware);

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const rootStore = createStore(
    rootReducer,
    initialState,
    DevTools
      ? compose(
        enhancer,
        DevTools.instrument()
      )
      : enhancer
  );
  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  // if (module.hot) {
  //   module.hot.accept('../reducers', () =>
  //     store.replaceReducer(require('../reducers')/*.default if you use Babel 6+ */)
  //   );
  // }
  return rootStore;
};
